import React from "react"
import BlogPosts from '../components/blog-posts'
import WuformButton from '../components/wuform-button'
import HowvideoDemolition from "../components/howvideo-demolition"
import LayoutDemolition from "../components/layout-demolition"
import SuccessBtnDemolition from "../components/success-btn-demolition"

const PROGUIDEPAGEDEMOLITION = ({ pageContext }) => 
{ 
    const code = pageContext.code;
    const posts = pageContext.posts;
    const env = pageContext.env;      

    const seo = 
    {
        url: 'pro/guide',
        env: env,
        code: code,
        page: 'guides'
    }

    return (
        <LayoutDemolition seo={seo} env={env} hidden={true} callToAction={true}>
            <div className="blog">
                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8">
                            <BlogPosts posts={posts}/>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar no-margin">
                                <div className="block">
                                    <WuformButton env={env} />
                                </div> 

                                <div className="block">
                                    <HowvideoDemolition/> 
                                </div>
                                
                                <div className="block">                                    
                                    <SuccessBtnDemolition />
                                </div>                                        
                            </div>                            
                        </div>
                    </div>
                </div>           
            </div> 
        </LayoutDemolition>
    )
};

export default PROGUIDEPAGEDEMOLITION;